import { render, staticRenderFns } from "./SignatureHeader.vue?vue&type=template&id=66e48095&scoped=true"
import script from "./SignatureHeader.vue?vue&type=script&lang=js"
export * from "./SignatureHeader.vue?vue&type=script&lang=js"
import style0 from "./SignatureHeader.vue?vue&type=style&index=0&id=66e48095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e48095",
  null
  
)

export default component.exports